import { styled, Stack } from '@mui/material';

export const DesktopWrapper = styled('div')`
  display: none;
  @media screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 4.625rem;
  }
`;

export const MobileWrapper = styled('div')`
  display: flex;
  gap: 1rem;
  padding: ${({ theme }) => theme.spacing(0, 6, 6)};
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const Fieldset = styled('fieldset')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Legend = styled('legend')`
  margin-bottom: 1.25rem;
`;

export const SortButtons = styled(Stack)``;

export const SortButton = styled('button')<{ active?: boolean }>`
  cursor: pointer;
  padding: ${({ theme }) => theme.spacing(1, 4)};
  font-size: ${({ theme }) => theme.spacing(4)};
  background-color: ${({ theme, active }) =>
    active ? theme.palette.primary.main : 'transparent'};
  border: 2px solid ${({ theme, active }) => theme.palette.primary.main};
  color: ${({ theme, active }) =>
    active ? theme.palette.grey[50] : theme.palette.primary[700]};
  height: 100%;

  &:first-child {
    padding-left: ${({ theme }) => theme.spacing(6)};
    border-top-left-radius: ${({ theme }) => theme.spacing(5)};
    border-bottom-left-radius: ${({ theme }) => theme.spacing(5)};
    border-right-width: 0;
  }
  &:last-child {
    border-top-right-radius: ${({ theme }) => theme.spacing(5)};
    border-bottom-right-radius: ${({ theme }) => theme.spacing(5)};
    padding-right: ${({ theme }) => theme.spacing(6)};
    border-left-width: 0;
  }
`;
